class ApiSource {
  constructor() {
    this.meta = this.getMeta()
    this.data = this.getJson()
  }

  getJson() {
    var req = new XMLHttpRequest()
    const meta = this.meta
    var response = []
    req.onreadystatechange = function () {
      if (this.readyState === this.DONE) {
        if (req.status === 200) {
          response = JSON.parse(req.responseText)
          response = { data: response }
          const building1 = {
            number: '1',
            apartments: []
          }
          if (meta.name === 'Kolejowa') {
            response.data.forEach((building) => {
              building.apartments.forEach(a => {
                if (a.stageName === 'I') building1.apartments.push(a)
              })

              // building.apartments = building.apartments.filter((apartment) => {
              //   if (apartment.stageName === 'I') return apartment
              // })

              // return building
            })
            response.data = [building1]
          }
        }
      }
    }

    let url = this.meta.api
    req.open('GET', url, false)
    req.send()
    return response
  }

  getMeta() {
    var req = new XMLHttpRequest()

    var response = null
    req.onreadystatechange = function () {
      if (this.readyState === this.DONE) {
        response = JSON.parse(req.responseText)
      }
    }

    let basePath = '/'
    if (process.env.VUE_APP_APP_BASE_PATH) {
      basePath = process.env.VUE_APP_APP_BASE_PATH
    }
    req.open('GET', `${basePath}/meta.json`, false)
    req.send()

    return response
  }

  parseMeta(data) {
    let meta = this.meta.data
    let buildings = data.data

    let parsedData = []
    if (buildings) {
      for (let i = 0; i < meta.length; i++) {
        let metaItem = meta[i]

        for (let j = 0; j < buildings.length; j++) {
          let building = buildings[j]

          if (metaItem['number'] === building['number']) {
            building['meta'] = metaItem.meta
            parsedData.push(building)
          }
        }
      }
    }

    let result = []
    result['data'] = parsedData
    return result
  }

  getInvestmentMetaTitle() {
    return this.meta.meta.title
  }

  getEndpoint() {
    return this.meta.endpoint
  }

  getWithoutInvestment() {
    return this.meta.withoutInvestment
  }

  getHasInvestmentMiniature() {
    return this.meta.hasInvestmentMiniature
  }

  getCompassInvestmentViewStart() {
    return this.meta.compassInvestmentViewStart
  }

  getInvestmentImageSource() {
    let basePath = '/'
    if (process.env.VUE_APP_APP_BASE_PATH) {
      basePath = process.env.VUE_APP_APP_BASE_PATH
    }

    return basePath + this.meta.investmentImage
  }

  getInvestmentColiderSource() {
    let basePath = '/'
    if (process.env.VUE_APP_APP_BASE_PATH) {
      basePath = process.env.VUE_APP_APP_BASE_PATH
    }

    return basePath + this.meta.investmentColider
  }

  getFiltersStyle() {
    return this.meta.filtersStyle
  }

  getCloseIconStyle() {
    return this.meta.closeIconStyle
  }

  getCSSVariables() {
    return this.meta.styles && this.meta.styles.CSSVariables ? this.meta.styles.CSSVariables : null
  }

  getSelectBuildingTooltipConfig() {
    return this.meta?.selectBuildingTooltip
  }

  all() {
    return this.parseMeta(this.data)
  }
}

export default ApiSource
